var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label}},[_c('base-picker',{attrs:{"minute-interval":15,"hour-range":[[0, 10]],"manual-input":"","input-width":"100%"},on:{"change":function($event){return _vm.$emit('change', _vm.duration)}},model:{value:(_vm.duration),callback:function ($$v) {_vm.duration=$$v},expression:"duration"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }